import { Component } from '@angular/core';
import { AuthenticationService } from './data-services/authentication.service';

@Component({
    selector: 'ebb-v2-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class TrainingAppComponent {
  title = 'ebb-app-training';


  constructor(

  ) {
   
 
  }

 
}
